import {getLocalStorage} from "../components/Utils";

const ApplicationData = {
	currentPage: getLocalStorage('currentPage') || 'home',
	user: null, // Add any additional data you want to track globally  
	BASE_URL: undefined,
	choicePairsList: undefined,
	intl: undefined,
	countDownMap: {},
	lang: undefined,
	tagLabelLocalised: undefined,
	TopStoriesResults: [],
	resetTopStoriesCount: 0,
	authToken:undefined,
    setAuthToken:undefined, // Provide the function to update authToken
	enableStripe: true,
	// enableStripe: false,
};

export default ApplicationData;
